import { render, staticRenderFns } from "./UniversityMain.vue?vue&type=template&id=91ba47e0&scoped=true&"
import script from "./UniversityMain.vue?vue&type=script&lang=js&"
export * from "./UniversityMain.vue?vue&type=script&lang=js&"
import style0 from "./UniversityMain.vue?vue&type=style&index=0&id=91ba47e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ba47e0",
  null
  
)

export default component.exports